import { render, staticRenderFns } from "./m-edit-lightbox-url.vue?vue&type=template&id=1d203a0b&scoped=true&"
import script from "./m-edit-lightbox-url.vue?vue&type=script&lang=js&"
export * from "./m-edit-lightbox-url.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d203a0b",
  null
  
)

export default component.exports